import { ServiceNoteViewModel } from "src/app/view-models/orders/service-note.view-model";
import { StoredServiceNote } from "../models/stored-orders/stored-service-note";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between ServiceNote view model and database StoredServiceNote.
 */
export class ServiceNoteMapper implements IStoredMapper<ServiceNoteViewModel, StoredServiceNote> {
	/**
	 * Maps a ServiceNote to a StoredServiceNote.
	 * @param serviceNote The service note data to convert.
	 * @returns A StoredServiceNote object.
	 */
	public ToStored(serviceNote: ServiceNoteViewModel): StoredServiceNote {
		return {
			Note: serviceNote.Note,
			Type: serviceNote.Type,
			Timestamp: serviceNote.Timestamp
		};
	}

	/**
	 * Maps a StoredServiceNote to a ServiceNote.
	 * @param storedServiceNote The stored service note data to convert.
	 * @returns A ServiceNote object.
	 */
	public FromStored(storedServiceNote: StoredServiceNote): ServiceNoteViewModel {
		return {
			Note: storedServiceNote.Note,
			Type: storedServiceNote.Type,
			Timestamp: storedServiceNote.Timestamp
		};
	}
}